webpackJsonp([154910056938736],{

/***/ 1763:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"DialpadOffice","kind":"OBJECT","type":"OBJECT","fields":[{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"officeId","type":{"kind":"SCALAR","name":"String","ofType":null}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"officeName","type":{"kind":"SCALAR","name":"String","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---object-dialpad-office-541722fd6dcff00eb124.js